module.exports = __webpack_public_path__ + "static/img/ElevatorPitch.a3da4c63.jpg";